<template>
  <div class="contenedor">
    <h4>{{emailaccount}}</h4>
              <vue-form-generator
                  :schema="schemaStatus"
                  :model="filtermodel"
                  :options="formOptions"
              ></vue-form-generator>
              <button class="btn btn-sm btn-primary" @click="filter()">filter</button>
              <div>
                <i class="icon-checkmark text-success"></i> <small>E-mails enregistrés dans Oliverlist</small><br>
                <i class="icon-close text-danger"></i>  <small>E-mails non enregistrés : </small><br>
                      <small>Les e-mails non enregistrés peuvent être dus à deux raisons : rebond ou warmy. Si aucune de ces raisons ne se présente, c’est une erreur.</small>
            </div>
                  <LoadingSpinner v-if="loading" />

    <div v-for="email in emails" class="card my-2 p-1"> 
             <small class="text-secondary">Email Id:   {{email.id}}</small>
      <GetEmailWithApi :selectedEmailId="email.id" :email="emailaccount"></GetEmailWithApi>
    </div>
  </div>
</template>
<script>
import {
  emailsService
} from "@/_services";

import GetEmailWithApi from "@/components/Emails/GetEmailWithApi.vue";
import VueFormGenerator from "vue-form-generator";
import LoadingSpinner from "@/components/LoadingSpinner.vue";


export default {

  components: {
    GetEmailWithApi,
    LoadingSpinner,
        "vue-form-generator": VueFormGenerator.component,
  },
  props: { user_id: String, email: String },
  data() {
    return {
        emails: [],
        result: false,
        filtermodel: {},
        loading: true,
        email: '',
            formOptions: {
                validateAfterLoad: false,
                validateAfterChanged: true,
            },
            schemaStatus: {
               fields: [

                    {
                      type: "input",
                      inputType: 'date',
                      label: 'Emails From',
                      model: "from",
                      featured: false,
                        styleClasses: "col-md-3"
                    },
                    {
                      type: "input",
                      inputType: 'date',
                      label: 'Emails To',
                      model: "to",
                      featured: false,
                        styleClasses: "col-md-3"
                    },
                ]
            }
    }
  },
  created() {
    this.filter();
  },
  methods: {
    filter() {
        this.emails = [];
        emailsService.getLastEmails(this.user_id,this.filtermodel).then(
          (result) => {
            this.result = result;
            this.loading = false;
            if(result[1].result.messages){
              this.emails = result[1].result.messages
            }else{
              this.emails = result[1].result
            }
            this.emailaccount =  result[0].email
          }
        );
    }
  }
};
</script>
